module.exports = __webpack_public_path__ + "static/img/logo3.c3e143e2.png";